import React from "react";
import { CircularProgress } from "@material-ui/core";

const FullPageLoader = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "#FFFFFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default FullPageLoader;
